// extracted by mini-css-extract-plugin
export default {"button":"buttonWithVariable_button__V9G9s"};